import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";
import Products from "./Products";
import ListOfIframes from "./ListOfIframes";
import AdminPartnerSelect from "../Components/AdminPartnerSelect";

// iOS segment control — same style as AdminDashboard
const iosSegmentSx = {
  bgcolor: "rgba(118,118,128,0.12)",
  borderRadius: "9px",
  p: "2px",
  "& .MuiToggleButtonGroup-grouped": {
    border: "none !important",
    borderRadius: "7px !important",
  },
  "& .MuiToggleButton-root": {
    border: "none",
    borderRadius: "7px",
    px: 2.5,
    py: 0.75,
    fontSize: "0.8125rem",
    fontWeight: 500,
    color: "text.secondary",
    textTransform: "none",
    letterSpacing: "-0.01em",
    lineHeight: 1.4,
    minWidth: 72,
    "&.Mui-selected": {
      bgcolor: "white",
      color: "text.primary",
      fontWeight: 600,
      boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 1px rgba(0,0,0,0.06)",
      "&:hover": { bgcolor: "white" },
    },
    "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
  },
};

// Affiliate Products — SKUs (left, default) and Amazon List (right)
const ShopProducts = () => {
  const [activeTab, setActiveTab] = useState("skus");

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 2,
          mb: 3,
          flexWrap: "wrap",
        }}
      >
        <ToggleButtonGroup
          value={activeTab}
          exclusive
          onChange={(_, v) => {
            if (v !== null) setActiveTab(v);
          }}
          sx={iosSegmentSx}
        >
          <ToggleButton value="skus">SKUs</ToggleButton>
          <ToggleButton value="amazon">Amazon List</ToggleButton>
        </ToggleButtonGroup>
        <Box sx={{ width: { xs: "100%", sm: 300 }, maxWidth: "100%", flexShrink: 0 }}>
          <AdminPartnerSelect />
        </Box>
      </Box>

      {activeTab === "skus" && <Products />}
      {activeTab === "amazon" && <ListOfIframes />}
    </Box>
  );
};

export default ShopProducts;
